<template>
  <div id="mine" v-loading="loading">
    <el-row v-loading="loading">
      <el-col :span="24" style="padding-left: 20px;padding-right: 20px;">
        <el-table
          :data="list"
          border
          style="width: 100%">

          <el-table-column
            label="序号"
            width="50"
            prop="index">
          </el-table-column>

          <el-table-column
            label="美食图片"
            width="100">
            <template slot-scope="scope">
              <img v-lazyload src="../../static/loading.svg" :data-src="scope.row.cover" class="app-image" data-err="../../static/df.png">
            </template>
          </el-table-column>

          <el-table-column
            label="标题"
            prop="title">
          </el-table-column>

          <el-table-column
            label="所在城市"
            prop="city">
          </el-table-column>

          <el-table-column
            label="详细地址"
            prop="addr">
          </el-table-column>

          <el-table-column
            label="获得评论次数"
            prop="commentsLen">
          </el-table-column>

          <el-table-column
            label="创建时间"
            prop="ctDes">
          </el-table-column>

          <el-table-column
            label="操作"
            width="100">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="showDetail(scope.row.id)"
                type="text"
                size="small">
                查看
              </el-button>
            </template>
          </el-table-column>

        </el-table>

        <div style="text-align: right;margin-top: 10px;">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="changePage"
            :current-page.sync="pageInfo.current"
            :page-size="pageInfo.size"
            :total="pageInfo.total">
          </el-pagination>
        </div>

      </el-col>
    </el-row>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import _ from 'lodash'
  import nebulas from 'nebulas'

  export default {
    data () {
      return {
        listAll: [],
        list: [],
        loading: false,
        pageInfo: {current: 1, size: 5}
      }
    },
    methods: {
      // 查看书评详情
      showDetail: function (id) {
        this.$router.push({name: 'detail', query: {id: id}})
      },
      // 修改书评
      showPublish: function (id) {
        this.$router.push({name: 'publish', query: {id: id}})
      },
      // 获取书评列表
      getList: function () {
        var vueThis = this
        if (_.isEmpty(vueThis.accounts)) {
          vueThis.showErr('请先登录钱包！');
          return false;
        }
        vueThis.loading = true;
        let params = [vueThis.accounts[0]];
        vueThis.$store.dispatch('simulateCallNew', {funcName: 'getUserFoods', from: vueThis.accounts[0], params: params}).then((ret) => {
          let data = JSON.parse(ret);
          console.log('获取列表', data);
          vueThis.listAll = data;
          // 遍历增加序号
          _.forEach(vueThis.listAll, function (item, index) {
            item.index = index + 1;
            let d = new Date(item.ct);
            item.ctDes = d.toLocaleDateString() + ' ' + d.toLocaleTimeString();
            item.valueNas = nebulas.Unit.fromBasic(item.value, 'nas');
            item.valueNas = _.replace(item.valueNas, '"', '');
            item.commentsLen = item.comments.length;
          });
          vueThis.loading = false;
          vueThis.changePage(1);
        }, (error) => {
          vueThis.loading = false;
          vueThis.showErr('获取书评列表失败' + error);
        });
      },
      // 修改页码
      changePage (pageNum) {
        console.log('修改页码', pageNum);
        let vueThis = this;
        vueThis.loading = true;
        vueThis.list = [];
        let p = vueThis.pageInfo;
        p.current = !pageNum ? 1 : pageNum;
        let maxPage = Math.ceil(p.total / p.size);
        p.current = _.min([p.current, maxPage])
        p.total = _.get(vueThis.listAll, 'length', 0);

        let start = (p.current - 1) * p.size;
        let end = _.min([p.current * p.size, p.total]);

        vueThis.list = _.slice(vueThis.listAll, start, end);
        vueThis.loading = false;
      }
    },
    created () {
      this.getList()
    },
    computed: mapState([
      'accounts'
    ]),
    watch: {
      accounts (curVal, oldVal) {
        if (curVal) {
          console.log('检测用户发生变化，重新刷新数据')
          this.getList()
        }
      }
    }
  }
</script>

<style>
  #mine {
  }

  #mine .demo-table-expand {
    font-size: 0;
  }
  #mine .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  #mine .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }

  #mine .app-image{
    border-radius:20px;
    width: 80px;
    height: 80px;
    margin-bottom: 10px;
    object-fit: cover;
    box-shadow:0 4px 3px -2px rgba(0,0,0,.8), 0 0 3px 1px rgba(0,0,0,.05);
    transition:all .4s;
    vertical-align: middle;
    border-style: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/base-mine.vue